import React from 'react'
import { WidgetContent, Widget, Divider } from '@duik/it'
import { ModalButton } from '../UI/ModalButton'
import FormInputGroup from '../UI/FormInputGroup'
import CloseIcon from '@material-ui/icons/CloseRounded'
import { Formik, ErrorMessage } from 'formik'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import * as Yup from 'yup'

const SignOnOffModal = props => {
  const handleEditTime = (signOnTime, signOffTime) => {
    props.handleEditTime(signOnTime, signOffTime, props.editDetail._id)
    props.handleClose()
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1
      }}
    >
      <div
        style={{
          maxWidth: '540px',
          maxHeight: '300px',
          width: '100%',
          height: '100%',
          backgroundColor: 'white',
          borderRadius: '5px'
        }}
      >
        <Widget style={{ height: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 style={{ margin: '25px' }}>Sign On / Off</h3>
            <CloseIcon onClick={props.handleClose} className="closeIcon" />
          </div>

          <Divider />

          <Formik
            initialValues={{
              signOnTime:
                props.editDetail.signOnTime.length > 0 ? new Date(props.editDetail.signOnTime) : '',
              signOffTime:
                props.editDetail.signOffTime.length > 0
                  ? new Date(props.editDetail.signOffTime)
                  : ''
            }}
            validationSchema={TimeSchema}
            // handleSubmit={e => console.log(e)}
            onSubmit={values => {
              const { signOnTime, signOffTime } = values
              handleEditTime(signOnTime, signOffTime)
            }}
            render={({
              values,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <WidgetContent
                  style={{
                    height: '152px',
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#FBFBFD'
                  }}
                >
                  {/* {props.checkedItems.length > 0 && (
                    <div>
                      <p>{props.checkedItems.length} drivers selected</p>
                    </div>
                  )} */}
                  <FormInputGroup horizontal>
                    <div>
                      <span className="uik-content-title__wrapper">Sign On</span>
                      <div>
                        <DatePicker
                          selectsStart
                          className="uik-input__input halfWidthInputBox"
                          name="signOnTime"
                          selected={values.signOnTime}
                          onChange={e => setFieldValue('signOnTime', e)}
                          // value={values.signOnTime}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="HH:mm"
                          timeCaption="Time"
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        <ErrorMessage
                          name="signOnTime"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </div>
                    </div>
                    <div>
                      <span className="uik-content-title__wrapper">Sign Off</span>
                      <div>
                        <DatePicker
                          selectsEnd
                          className="uik-input__input halfWidthInputBox"
                          onBlur={handleBlur}
                          name="signOffTime"
                          selected={values.signOffTime}
                          onChange={e => setFieldValue('signOffTime', e)}
                          // value={values.signOffTime}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="HH:mm"
                          minDate={values.signOnTime}
                          autoComplete="off"
                        />
                        <ErrorMessage
                          name="signOffTime"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </div>
                    </div>
                  </FormInputGroup>
                </WidgetContent>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    margin: '0 25px',
                    height: '78px',
                    alignItems: 'center'
                  }}
                >
                  <div style={{ width: '83px' }}>
                    <ModalButton buttonStyle="tertiary" name="Cancel" onClick={props.handleClose} />
                  </div>
                  <div style={{ width: '83px' }}>
                    <ModalButton
                      buttonStyle="primary"
                      type="submit"
                      disabled={isSubmitting}
                      name="Save"
                    />
                  </div>
                </div>
              </form>
            )}
          />
        </Widget>
      </div>
    </div>
  )
}

export default SignOnOffModal

Yup.addMethod(Yup.object, 'atLeastOneOf', function(list) {
  return this.test({
    name: 'atLeastOneOf',
    message: 'Please select a start or end time',
    exclusive: true,
    params: { keys: list.join(', ') },
    test: value => value == null || list.some(f => value[f] != null)
  })
})

const TimeSchema = Yup.object()
  .shape({
    signOnTime: Yup.string(),
    signOffTime: Yup.string()
  })
  .atLeastOneOf(['signOnTime', 'signOffTime'])
